import { render, staticRenderFns } from "./TitularesTable.vue?vue&type=template&id=54902e4a"
import script from "./TitularesTable.vue?vue&type=script&lang=js"
export * from "./TitularesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports